import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { Box, Typography, Button, TextField, Stack, Alert } from '@mui/material';
import BlogsIcon from './BlogsIcon';
import { color, font } from '../styles/tokens';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const successMessage = location.state?.message;

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!username.trim() || !password) {
      setError('Enter your username and password.');
      return;
    }
    setSubmitting(true);
    try {
      const response = await axios.post('/api/auth/login', { username: username.trim(), password });
      const { token, role } = response.data;
      localStorage.setItem('token', token);
      if (role === 'superadmin') {
        history.push('/admin');
      } else {
        history.push('/dashboard');
      }
    } catch (err) {
      setError(err?.response?.data?.message || 'Invalid username or password');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh', width: '100vw', position: 'relative',
        display: 'grid', placeItems: 'center', overflow: 'hidden',
        background: `radial-gradient(900px 420px at 82% 8%, ${color.cyanGlow}, transparent 60%), ${color.ink}`,
      }}
    >
      <Box
        className="wd-bracket"
        sx={{
          position: 'relative', zIndex: 1, width: 'min(380px, 90vw)',
          background: color.glass, backdropFilter: 'blur(14px)', WebkitBackdropFilter: 'blur(14px)',
          border: `1px solid ${color.cyanDim}`, p: { xs: 3, sm: 4 },
          filter: `drop-shadow(0 0 26px ${color.cyanGlow}) drop-shadow(0 24px 50px rgba(0,0,0,.55))`,
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Box sx={{ width: 48, height: 48, borderRadius: '50%', background: '#fff', display: 'grid', placeItems: 'center', overflow: 'hidden' }}>
            <BlogsIcon style={{ width: 48, height: 48, borderRadius: 0, boxShadow: 'none' }} />
          </Box>
        </Box>
        <Typography sx={{ fontFamily: font.mono, fontSize: '.6875rem', letterSpacing: '.14em', textTransform: 'uppercase', color: color.cyan, textAlign: 'center', mb: 1 }}>
          Credential required
        </Typography>
        <Typography sx={{ fontFamily: font.display, fontWeight: 600, fontSize: '1.35rem', color: color.bone, textAlign: 'center', mb: 0.5 }}>
          Sign in to the wire
        </Typography>
        <Typography sx={{ color: color.boneFaint, fontSize: '.8125rem', textAlign: 'center', mb: 3 }}>
          Enter your callsign and passcode to reach the desk.
        </Typography>
        {successMessage && <Alert severity="success" sx={{ mb: 2 }}>{successMessage}</Alert>}
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <form onSubmit={handleSubmit}>
          <Stack spacing={2}>
            <TextField
              label="Callsign"
              value={username}
              onChange={e => setUsername(e.target.value)}
              fullWidth
              required
              autoFocus
            />
            <TextField
              label="Passcode"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              fullWidth
              required
            />
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={submitting}>
              {submitting ? 'Signing in…' : 'Sign in'}
            </Button>
          </Stack>
        </form>
        <Typography variant="body2" sx={{ mt: 3, textAlign: 'center', color: color.boneFaint }}>
          New here? <Link to="/Regentix" style={{ color: color.cyan }}>Create an account</Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default Login;
